<main
    class="overflow-x-hidden absolute z-[999] inset-0 w-full min-h-screen h-full slide bg-white"
>
    <header
        [class.safe-top]="platform === 'ios'"
        #header
        class="flex fixed z-10 flex-col gap-[34px] p-4 w-full md:gap-5 bg-primary"
    >
        <div class="h-5">
            <app-icon
                (click)="goBack()"
                name="material-symbols:arrow-back-ios"
                class="text-white cursor-pointer"
                size="sm"
            />
        </div>
        <div class="flex justify-between items-center">
            <h1 class="text-2xl font-semibold text-white">마이 페이지</h1>
            <img src="logo5.svg" class="size-16" alt="마이페이지 이미지" />
        </div>
    </header>

    <div [style.height.px]="headerHeight()"></div>
    <section
        class="container max-w-[554px] w-full overflow-hidden bg-white rounded-t-2xl"
    >
        <router-outlet />
    </section>
</main>
